var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72113 2.05149L18.0756 9.61746C18.3233 9.73952 18.4252 10.0393 18.3031 10.287C18.2544 10.3858 18.1744 10.4658 18.0756 10.5145L2.72144 18.0803C2.47374 18.2023 2.17399 18.1005 2.05193 17.8528C1.99856 17.7445 1.98619 17.6205 2.0171 17.5038L3.9858 10.0701L2.01676 2.62789C1.94612 2.36093 2.10528 2.08726 2.37224 2.01663C2.48893 1.98576 2.61285 1.99814 2.72113 2.05149ZM3.26445 3.43403L4.87357 9.51612L4.93555 9.50412L5 9.5H12C12.2761 9.5 12.5 9.72386 12.5 10C12.5 10.2455 12.3231 10.4496 12.0899 10.4919L12 10.5H5C4.9686 10.5 4.93787 10.4971 4.90807 10.4916L3.26508 16.6976L16.7234 10.066L3.26445 3.43403Z",
    fill: "#50595F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7211 2.05149L38.0756 9.61746C38.3233 9.73952 38.4252 10.0393 38.3031 10.287C38.2544 10.3858 38.1744 10.4658 38.0756 10.5145L22.7214 18.0803C22.4737 18.2023 22.174 18.1005 22.0519 17.8528C21.9986 17.7445 21.9862 17.6205 22.0171 17.5038L23.5384 11.7591C23.5887 11.5691 23.7456 11.4262 23.9395 11.3939L30.8204 10.2466C30.9047 10.2325 30.9744 10.1769 31.0079 10.1012L31.0259 10.0411C31.0454 9.92436 30.9805 9.81305 30.8759 9.76934L30.8204 9.7534L23.9006 8.6001C23.7067 8.56778 23.5497 8.4248 23.4994 8.23473L22.0168 2.62789C21.9461 2.36093 22.1053 2.08726 22.3722 2.01663C22.4889 1.98576 22.6128 1.99814 22.7211 2.05149Z",
    fill: "#3C82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChat);
export default __webpack_public_path__ + "static/media/sendChat.996aec6d55619ce9105e61f232586335.svg";
export { ForwardRef as ReactComponent };